const breadcrumbsData = [
  {
    title: 'Home',
    path: process.env.REACT_APP_ROOT_URL,
  },
  {
    title: 'Supply',
    children: [
      { title: 'Inbound Shipments', path: '/core/supply/shipment' },
      { title: 'Inbound Deliveries', path: '/core/supply/delivery'},
      { title: 'Purchase Orders', path: '/core/supply/order'}
    ],
  },
  {
    title: 'Inbound Shipments',
    path: '/core/supply/shipment',
    children: [],
  },
  {
    title: 'Inbound Deliveries',
    path: '/core/supply/delivery',
    children: [],
  },
  {
    title: 'Purchase Orders',
    path: '/core/supply/order',
    children: [],
  },
  {
    title: 'Demand',
    children: [
      { title: 'Outbound Shipments', path: '/core/demand/shipment' },
      { title: 'Outbound Deliveries', path: '/core/demand/delivery' },
      { title: 'Sales Orders', path: '/core/demand/order' }
    ],
  },
  {
    title: 'Outbound Shipments',
    path: '/core/demand/shipment',
    children: [],
  },
  {
    title: 'Outbound Deliveries',
    path: '/core/demand/delivery',
    children: [],
  },
  {
    title: 'Sales Orders',
    path: '/core/demand/order',
    children: [],
  },
  {
    title: 'Inventory',
    children: [
      { title: 'Inventory', path: '/core/inventory/node/inventory' },
      { title: 'Warehouse Capacity', path: '/warehouse-capacity' }
    ]
  },
  {
    title: 'Inventory List',
    path: '/core/inventory/node/inventory',
    children: [],
  },
  {
    title: 'Master Data',
    children: [
      { title: 'Currency Conversion', path: '/core/inventory/node/inventory' },
      { title: 'Fiscal Calendar', path: '/warehouse-capacity' },
      { title: 'Documents', path: '/documents' },
      { title: 'Items', path: '/items' },
      { title: 'Sites', path: '/sites' },
      { title: 'Nodes', path: '/nodes' },
      { title: 'Sourcing Lanes', path: '/sourcing-lanes' },
      { title: 'Participants', path: '/participants' },
      { title: 'Batches', path: '/batches' }
    ]
  },
  {
    title: 'Currency Conversion',
    path: '/core/master-data/currency-conversion',
    children: [],
  },
]

export default breadcrumbsData;